import {ValueObject} from '@s-ui/domain'

export default class ResultValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {Boolean} data.ok
   */

  /**
   * Validation method
   */
  static validate({ok}) {
    if (typeof ok !== 'boolean') {
      throw new Error('Result should be Ok or KO')
    }
  }
}
